(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company', {
                parent: 'admin',
                url: '/company',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'abcQualityMatchApp.company.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/company/companies.html',
                        controller: 'CompanyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-detail', {
                parent: 'admin',
                url: '/company/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'abcQualityMatchApp.company.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/company/company-detail.html',
                        controller: 'CompanyDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                        return Company.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'company',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('company-detail.edit', {
                parent: 'company-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.getDto({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company.new', {
                parent: 'company',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    streetAddress: null,
                                    postCode: null,
                                    city: null,
                                    tel: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('company');
                    });
                }]
            })
            .state('company.edit', {
                parent: 'company',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.getDto({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company.delete', {
                parent: 'company',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-delete-dialog.html',
                        controller: 'CompanyDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
